<template>
  <div>
    <div class="con-tit">提单确认</div>
    <div class="shanmgchuan">
      <div
        v-for="(item, index) in localFilesList"
        :key="index"
        class="sc-child"
      >
        <div class="fujian">
            <div class="word">{{item.file_name}}</div>
            <el-button type="text" @click="download(item)">下载</el-button>
        </div>
      </div>
      <!-- :headers="headers" -->
      <!-- <el-upload
        class="upload-demo"
        action="https://serve.dhcang.com/api/upload/file"
        :on-success="PODSuccess"
        multiple
        :show-file-list="false"
      >
        <el-button class="sc_btn" size="small" type="primary" text
          >点击上传</el-button
        >
      </el-upload> -->
    </div>
    <div class="neirong">
      <div class="nr">
        <div class="nr-t">提单备注</div>
        <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入内容"
        v-model="form.lading_bill_remarks_user">
        </el-input>
      </div>
    </div>
    <div class="tiojiao">
        <el-button @click="confirm">提单确认</el-button>
    </div>
  </div>
</template>
     
<script>
import { confirmLadingBillInfo } from "@/api/api";
export default {
  components: {},
  props: {
    parentMessage:{
        type:Object,
        required:true
    },
  },
  data() {
    return {
      localFilesList: [],
      form:{
        order_id:'',
        lading_bill_remarks_user:'', // 订舱备注-用户端
      }
    };
  },
  methods: {
    // 提单确认
    async confirm(){
        // confirmCutOffInfo
        try {
            this.form.order_id=this.parentMessage.order_id
            
            const res = await confirmLadingBillInfo(this.form,this.headers)
            if(res.code==1){
                this.$message({
                    type:'success',
                    message:'提单确认成功'
                })
                this.active=2
            }else{
                this.$message({
                    type:'error',
                    message:res.msg
                })
            }
        } catch (error) {
            console.log(error,'失败');
        }
    },
    async submitBill() {
      let id = this.$route.query;
      try {
        const res = await confirmLadingBillInfo({
          id,
          files: this.localFilesList,
        });

        if (res.code == 1) {
          this.$message({
            message: "文件上传成功",
            type: "success",
          });
        }
      } catch (error) {
        console.log(error, "错误");
      }
    },
    download(e) {
        const link = document.createElement('a');
        link.href = e.file_url;
        link.setAttribute('download', '');
        document.body.appendChild(link);
        link.click();
        document.bodyNaNpxoveChild(link);
    },
  },
  mounted() {
    this.form.lading_bill_remarks_user = this.parentMessage.lading_bill_remarks_user
    if(this.parentMessage.files.length>0){
      for (let i = 0; i < this.parentMessage.files.length; i++) {
        if(this.parentMessage.files[i].type==51){
          this.localFilesList.push(this.parentMessage.files[i])
        }
      }
    }
  },
  created() {

  },
};
</script>
  
<style style lang="scss" scoped>
.shanmgchuan {
  display: flex;
  align-items: flex-end;
  .el-button {
    margin-left: 50px;
    margin-top: 32px;
  }

  .sc-child{
    margin-right: 24px;
  }
}
.pdf_tit {
  font-size: 16px;
  color: #333333;
  margin: 20px 0;
}

.pdf {
  width: 400px;
  height: 72px;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  cursor: pointer;
  .pdf-t {
    width: 56px;
    height: 56px;
    background: #e64e3b;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 56px;
    margin-left: 8px;
  }

  .pdf-click {
    font-size: 14px;
    color: #999999;
    margin-left: 12px;
  }
}

.tuisomg {
  text-align: center;
  margin-top: 32px;
}

.con-tit {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #333333;
  font-style: normal;
  text-transform: none;

  padding-top: 12px;
  padding-bottom: 24px;
}

:deep(.el-textarea){
    textarea{
        width: 400px;
        height: 140px;
        background: #F9F9F9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
    }
}
.neirong{
    margin-bottom: 20px;
    .nr{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }


    .nr-t{
        // width: 100px;
        width: 85px;
        height: 20px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #606260;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        margin-top: 24px;
        margin-bottom: 12px;
    }
}

.tiojiao{
    text-align: center;
    .el-button{
        width: 120px;
        height: 48px;
        background: #0073F5;
        border-radius: 8px 8px 8px 8px;
        color: #fff;
    }
}

.fujian{
    // width: 200px;
    display: flex;
    align-items: center;
    .word{
        width: 280px;
        // background: pink;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .el-button{
        margin-left: 12px;
        margin-top: 0;
    }
}
</style>